/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const isSuccessResponse = (response: Response) => {
  const { status } = response;
  if (status >= 200 && status <= 299) {
    return true;
  }
  if (status === 400) {
    return true;
  }
  return false;
};

export const isErrorResponse = (response: Response) =>
  !isSuccessResponse(response);
/* eslint-enable */
